import {
  type InfiniteData,
  type QueryClient
} from 'react-query'

type FeedPage = {
  page: {
    data: {
      data: any[]
      [key: string]: any
    }
    [key: string]: any
  }
  nextCursor?: string
}

export const insertPostIntoProfileQuery = (
  queryClient: QueryClient,
  queryKey: readonly unknown[],
  post: any
) => {
  if (!post?.id) return

  queryClient.setQueryData<InfiniteData<FeedPage>>(
    queryKey,
    previous => {
      if (!previous?.pages?.length) {
        return {
          pages: [
            {
              page: {
                data: {
                  status: 'OK',
                  code: 200,
                  data: [post],
                  meta: {
                    next_cursor: null,
                    prev_cursor: null
                  }
                }
              },
              nextCursor: undefined
            }
          ],
          pageParams: [undefined]
        }
      }

      const pages = previous.pages.map(page => ({
        ...page,
        page: {
          ...page.page,
          data: {
            ...page.page.data,
            data: (page.page.data.data ?? []).filter(
              existing =>
                String(existing.id) !== String(post.id)
            )
          }
        }
      }))

      pages[0] = {
        ...pages[0],
        page: {
          ...pages[0].page,
          data: {
            ...pages[0].page.data,
            data: [
              post,
              ...pages[0].page.data.data
            ]
          }
        }
      }

      return {
        ...previous,
        pages
      }
    }
  )
}